import { Block } from "./blocknote";
import { flattenBlocks } from "./blocks";

type DiscriminateUnion<T, K extends keyof T, V extends T[K]> = Extract<T, Record<K, V>>;

type MapDiscriminatedUnion<T extends Record<K, string>, K extends keyof T> = {
  [V in T[K]]: DiscriminateUnion<T, K, V>;
};

type BlocksByIndex = MapDiscriminatedUnion<Block, "type">;

export function withBlock<K extends keyof BlocksByIndex>(
  content: Block[],
  type: K,
  fn: (b: BlocksByIndex[K]) => React.ReactNode,
) {
  const block = flattenBlocks(content).find((b) => b.type === type) as BlocksByIndex[K] | undefined;
  if (block) {
    return fn(block);
  }
  return null;
}

export function withBlocks<K extends keyof BlocksByIndex>(
  content: Block[],
  type: K,
  fn: (b: BlocksByIndex[K][]) => React.ReactNode,
) {
  const blocks = flattenBlocks(content).filter((b) => b.type === type) as BlocksByIndex[K][];
  if (blocks.length === 0) {
    return null;
  }
  return fn(blocks);
}
